export default __webpack_public_path__ + "media/images/faq/hero1920-72611d9fa549023e13fa1783c256c669.webp";